import axios from 'axios';
import requestInterceptor from './requestInterceptor';

const defaultMimeType = 'application/json';

const userLogsApiInstance = axios.create({
  baseURL: process.env.API_URL,
  timeout: 30000,
  headers: { 'Content-Type': defaultMimeType, Accept: defaultMimeType }
});

// Add a request interceptor
userLogsApiInstance.interceptors.request.use(requestInterceptor);

export default userLogsApiInstance;



// WEBPACK FOOTER //
// ./src/common/api/userLogsApi.js